import React, { Component } from 'react'
import ReactSpinner from 'react-spin'

export default class Spinner extends Component {
  render () {
    const config = {
      color: '#fff',
      lines: 13,
      length: 10,
      width: 2,
      scale: 4
    }

    return (
      <ReactSpinner config={config} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/Spinner.js